import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { IonicModule, MenuController } from '@ionic/angular';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuConfigService } from './menu-config.service';
import { APP_NAME } from 'src/app/shared/brand';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, RouterLink, RouterLinkActive, TranslatePipe],
})
export class MenuComponent {
  private menuCtrl = inject(MenuController);
  readonly menuConfig = inject(MenuConfigService);
  readonly appName = APP_NAME;

  /** Items filtrados por rol — computed signal reactiva. */
  readonly menuItems = this.menuConfig.items;
  /** Bottom items (Settings) — siempre visibles para usuarios autenticados. */
  readonly bottomItems = this.menuConfig.bottomItems;

  /** Cierra el menú con un pequeño delay para que routerLink procese
   *  la navegación primero. En desktop (type="reveal") no hay menú
   *  que cerrar, así que es un no-op. */
  closeMenu() {
    setTimeout(() => this.menuCtrl.close('main'), 150);
  }
}
